import React, {Fragment} from "react";

interface IProps {
	when: boolean;
	children: React.ReactNode;
}
export const Exists: React.FC<IProps> = ({when, children}) => {
	if (!when) {
		return null;
	}
	return <Fragment>{children}</Fragment>;
};
